import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { ExternalExamRegistrationStudentDetails } from '../../../../../api/types/external-exams/registration/external-exam-student-registration-eligibility';
import { UpdateRegistrationGradesRequest } from '../operations/update-registration-grades-operation';
import CancelButton from '../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../component/ui/buttons/approve-button/approve-buttons';

interface EditRegistrationGradesDialogProps {
  visible: boolean;
  onHide: () => void;
  registration: ExternalExamRegistrationStudentDetails | null;
  onApprove: (request: UpdateRegistrationGradesRequest) => void;
  loading: boolean;
}

export const EditRegistrationGradesDialog: React.FC<
  EditRegistrationGradesDialogProps
> = ({ visible, onHide, registration, onApprove, loading }) => {
  const [attended, setAttended] = useState<boolean>(false);
  const [internalGrade, setInternalGrade] = useState<number | null>(null);
  const [externalGrade, setExternalGrade] = useState<number | null>(null);
  const [finalGrade, setFinalGrade] = useState<number | null>(null);

  useEffect(() => {
    if (registration) {
      setAttended(registration.attended === true);
      setInternalGrade(registration.internalGrade ?? null);
      setExternalGrade(registration.externalGrade ?? null);
      setFinalGrade(registration.finalGrade ?? null);
    }
  }, [registration, visible]);

  const handleApprove = () => {
    if (registration) {
      onApprove({
        attended: attended,
        internalGrade: internalGrade,
        externalGrade: externalGrade,
        finalGrade: finalGrade,
      });
    }
  };

  if (!registration) {
    return null;
  }

  return (
    <Dialog
      header={`עריכת נוכחות וציונים: ${registration.userDetails.firstName} ${registration.userDetails.lastName}`}
      visible={visible}
      onHide={onHide}
      style={{
        width: '500px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
      closable={!loading}
    >
      <div style={{ direction: 'rtl', padding: '8px' }}>
        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            נכח
          </label>
          <Checkbox
            checked={attended}
            onChange={(e) => setAttended(e.checked ?? false)}
            disabled={loading}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            ציון מגן
          </label>
          <InputNumber
            value={internalGrade}
            onChange={(e) => setInternalGrade(e.value ?? null)}
            min={0}
            max={100}
            disabled={loading}
            style={{ width: '100%', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
            showButtons={true}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            ציון חיצוני
          </label>
          <InputNumber
            value={externalGrade}
            onChange={(e) => setExternalGrade(e.value ?? null)}
            min={0}
            max={100}
            disabled={loading}
            style={{ width: '100%', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
            showButtons={true}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            ציון סופי
          </label>
          <InputNumber
            value={finalGrade}
            onChange={(e) => setFinalGrade(e.value ?? null)}
            min={0}
            max={100}
            disabled={loading}
            style={{ width: '100%', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
            showButtons={true}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '20px',
          }}
        >
          <CancelButton onClick={onHide} disabled={loading} />
          <ApproveButtons onClick={handleApprove} isLoading={loading} />
        </div>
      </div>
    </Dialog>
  );
};
